import React, {useState} from 'react';
import TopBar from '../commons/TopBar';
import '../style/home.scss';
import '../style/privacy-policy.scss';
import PrivateSections from "./PrivateSections";


const PrivacyPolicy = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const handleAccordion = (idx: number) => {
        setOpenIndex(openIndex === idx ? null : idx);
    };

    return (
        <div className="home-container">
            <TopBar/>
            <div className="main-content privacy-policy-content">
                <h1 className="hero-title">Privacy Policy</h1>
                <div className="privacy-accordion">
                    {PrivateSections.map((section, idx) => (
                        <div className="accordion-section" key={section.title}>
                            <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                <span>{idx + 1}. {section.title}</span>
                                <span className="accordion-icon">{openIndex === idx ? '−' : '+'}</span>
                            </button>
                            <div className={`accordion-content${openIndex === idx ? ' open' : ''}`}>
                                {openIndex === idx && (
                                    <div className="accordion-inner">{section.content}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 